import { useContext, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Box,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import CircularIndicator from "../../elements/CircularIndicator";
import Typography from "@mui/material/Typography";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import { DataContext } from "../../../context/data-provider";
import axiosInstance from "../../../services/axios-instance";
import { CurrentWeekLogsInterface } from "../../../interface/currentWeekLogsInterface";
import { useOutletContext } from "react-router-dom";
import {
    All_USERS_URL,
    HOLIDAYS_REQUESTS_URL,
    SELECTED_USER_ID_URL,
    WEEKLY_LOGS_URL,
    GET_HOLIDAYS_DATELIST,
    NATIONAL_HOLIDAYS_URL,
    HOME_OFFICE_DAYS,
    HOME_OFFICE_DAYS_BY_ID
} from "../../../services/endpoints";
import VerticalProgressBar from "../../elements/VerticalProgressBar";
import { AllUsersInterface } from "../../../interface/allUsersInterface";
import { UserInterface } from "../../../interface/userInterface";
import { getHolidaysInCurrentMonth } from "../../utils/getHolidaysInCurrentMonth";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { MonthDataParams } from "../../../interface/monthDataInterface";
import { calculateHoursPerDay } from "../../utils/calculateHoursPerDay";
import DailyTasks from "../../elements/DailyTasks";
import TrackerForm from "../../elements/TrackerForm";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { NationalHolidaysInterface } from "../../../interface/nationalHolidayInterface";
import HomeWorkIcon from '@mui/icons-material/HomeWork';

const FirstGrid = styled(Box)(({ theme }) => ({
    gridColumn: "span 8",
    background: `linear-gradient(to right, ${theme.palette.common.white}, ${theme.palette.grey[300]})`,
    padding: theme.spacing(2),
    borderRadius: "8px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 100,
}));

const SecondGrid = styled(Box)(({ theme }) => ({
    gridColumn: "span 4",
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    height: 100,
    borderRadius: "8px",
}));

const Title = styled(Box)(({ theme }) => ({
    fontSize: theme.typography.h4.fontSize,
    fontWeight: "bold",
    color: theme.palette.primary.main,
}));

const Subtitle = styled(Box)(({ theme }) => ({
    fontSize: theme.typography.subtitle1.fontSize,
    color: theme.palette.grey[600],
    fontWeight: "bold",
}));

const List = styled("ul")({
    listStyle: "none",
    padding: 0,
    margin: 0,
});

const ListItem = styled("li")({
    backgroundColor: "#f9fafc",
    color: "#3B3B3B",
    borderRadius: "4px",
    padding: 10,
    margin: "0.5rem",
    fontSize: "12px",
});

type SelectedWeekType = number;
type FirstDayOfWeekType = Date;

const AdminDashboard = () => {
    const [selectedWeek, firstDayOfWeek] = useOutletContext() as [
        SelectedWeekType,
        FirstDayOfWeekType
    ];

    const [homeOfficeDaysCount, setHomeOfficeDaysCount] = useState<number>(0);

    const [homeOfficeStatus, setHomeOfficeStatus] = useState<string[]>([]);

    const [selectedItemIndices, setSelectedItemIndices] = useState<number[]>(
        []
    );

    const [editTaskDetails, setEditTaskDetails] =
        useState<CurrentWeekLogsInterface | null>(null);

    const [nationalHolidays, setNationalHolidays] = useState<
        NationalHolidaysInterface[]
    >([]);
    const [weeklyHolidays, setWeeklyHolidays] = useState<any[]>([]);
    const [showWeekendLog, setShowWeekendLog] = useState(false);
    const [users, setUsers] = useState<AllUsersInterface[]>([]);
    const [allListOfHolidays, setAllListOfHolidays] = useState<
        MonthDataParams[]
    >([]);

    const [currentSelectedUser, setCurrentSelectedUser] =
        useState<UserInterface>({
            id: 0,
            name: "",
            email: "",
            role_id: 0,
            available_days: 0,
            available_days_left: 0,
            available_days_current: 0,
            available_days_left_current: 0,
            available_days_prev: 0,
            available_days_left_all: 0,
            available_days_left_prev: 0,
            available_days_next: 0,
            available_days_left_next: 0,
            clients:[],
        });
    const [showInputForm, setShowInputForm] = useState(false);
    const [hideEditDeleteFunctionality, setHideEditDeleteFunctionality] =
        useState<boolean>(true);

    // Get the first day of the current week (Monday)
    // firstDayOfWeek is a string in format "YYYY-MM-DD" or undefined initially
    const startOfTheWeek = firstDayOfWeek ? new Date(firstDayOfWeek) : new Date();

    // Add the dates of each day in the current week (Monday to Friday)
    const daysOfWeek = [];
    const weekend = [];

    const isHomeOfficeDay = (weekDayDate : any) => {
        return homeOfficeStatus.some(record => record === weekDayDate);
    };

    const toggleHomeOffice = (weekDayDate : any) => {
        if(isHomeOfficeDay(weekDayDate)) {
            removeHomeOffice(weekDayDate);
            setHomeOfficeDaysCount(homeOfficeDaysCount - 1);
            setHomeOfficeStatus(homeOfficeStatus.filter(date => date !== weekDayDate));
        }
        else {
            addHomeOffice(weekDayDate);
            setHomeOfficeDaysCount(homeOfficeDaysCount + 1);
            setHomeOfficeStatus([
                ...homeOfficeStatus,
                weekDayDate
            ]);
        }
    };

    const addHomeOffice = async (weekDayDate : any) => {
        try {
            const resHomeOffice = await axiosInstance.post(
                HOME_OFFICE_DAYS,
                {
                    user_id: selectedUser,
                    dates: [weekDayDate],
                }
            );
            if (resHomeOffice.status === 200) {
                console.log("ok");
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };

    const removeHomeOffice = async (weekDayDate : any) => {

        try {
            const resHomeOffice = await axiosInstance.delete(HOME_OFFICE_DAYS_BY_ID, {
                data: 
                {
                    user_id: selectedUser,
                    date: weekDayDate,
                }
            });
            if (resHomeOffice.status === 200) {
                console.log("ok");
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }

    };
    

    for (let i = 0; i < 7; i++) {
        const date = new Date(startOfTheWeek);
        date.setDate(startOfTheWeek.getDate() + i);

        const weekdayNames = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];
        const weekdayName = weekdayNames[date.getDay()];

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        const weekDayDate = `${year}-${month}-${day}`;

        const weekDayTasks = {
            weekdayName,
            weekDayDate,
        };

        if (i < 5) {
            daysOfWeek.push(weekDayTasks);
        }
        else {
            weekend.push(weekDayTasks);
        }
    }

    const newCurrentDate = new Date().toLocaleDateString();

    const { currentUser } = useContext(DataContext);
    const [selectedUser, setSelectedUser] = useState<number | "">(currentUser.id || "");

    const selectedYear = new Date(firstDayOfWeek).getFullYear();

    const [openedDateTrackerForm, setOpenedDateTrackerForm] =
        useState<string>("");

    const [currentWeekLogs, setCurrentWeekLogs] = useState<
        CurrentWeekLogsInterface[]
    >([]);

    const toggleSelectedItem = (index: number) => {
        if (selectedItemIndices.includes(index)) {
            setSelectedItemIndices(
                selectedItemIndices.filter((i) => i !== index)
            );
        } else {
            setSelectedItemIndices([...selectedItemIndices, index]);
        }
    };

    
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axiosInstance.get(All_USERS_URL);
                setUsers(response.data.data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchUsers();
    }, []);

    useEffect(() => {
        const fetchNationalHolidays = async () => {
            try {
                const responseNatinalHolidays = await axiosInstance.get(
                    NATIONAL_HOLIDAYS_URL
                );
                setNationalHolidays(responseNatinalHolidays.data.data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchNationalHolidays();
    }, []);

    useEffect(() => {
        const fetchHomeOfficeStatus = async () => {
            // Only fetch if we have a valid date
            if (!firstDayOfWeek || !currentUser.id) {
                return;
            }

            try {
                const response = await axiosInstance.get(HOME_OFFICE_DAYS, {
                    params: {
                        user_id: currentUser.id,
                        from_date: firstDayOfWeek, // Already in YYYY-MM-DD format
                    }
                });
                setHomeOfficeStatus(response.data.map((item : any) => item.date));
            } catch (error) {
                console.error('Error fetching home office status:', error);
            }
        };

        fetchHomeOfficeStatus();
    }, [firstDayOfWeek, currentUser.id]);

    useEffect(() => {
        const getAvailableDays = async () => {
            const responseUserID = await axiosInstance.get(
                SELECTED_USER_ID_URL(currentUser.id ?? 1)
            );

            setCurrentSelectedUser(
                responseUserID.data.data
            );
        };

        getAvailableDays();
    }, []);

    useEffect(() => {
        const fetchWeeklyLogs = async () => {
            try {
                if (selectedUser) {
                    const responseHolidaysRequests = await axiosInstance.get(
                        HOLIDAYS_REQUESTS_URL(+selectedUser)
                    );
                    const response = await axiosInstance.get(
                        WEEKLY_LOGS_URL(
                            +selectedUser,
                            firstDayOfWeek.toString()
                        )
                    );
                    setCurrentWeekLogs(response.data.data);
                    setAllListOfHolidays(responseHolidaysRequests.data.data);
                }
            } catch (error) {
                console.error(error);
            }
        };
        const fetchWeeklyHoliday = async () => {
            try {
                if (selectedUser) {
                    const response = await axiosInstance.get(
                        GET_HOLIDAYS_DATELIST(
                            +selectedUser,
                            firstDayOfWeek.toString()
                        )
                    );
                    setWeeklyHolidays(response.data);
                }
            } catch (error) {
                console.error(error);
            }
        };

        const fetchHomeOfficeDays = async () => {
            try {
                if (selectedUser) {
                    const response = await axiosInstance.get(HOME_OFFICE_DAYS, {
                        params: {
                            user_id: selectedUser,
                            month: new Date().getMonth() + 1,
                        }
                    });
                    setHomeOfficeDaysCount(response.data.length);
                }
            } catch (error) {
                console.error(error);
            }
        };

        const fetchHomeOfficeStatus = async () => {
            // Only fetch if we have a valid date
            if (!firstDayOfWeek || !currentUser.id) {
                return;
            }

            try {
                const response = await axiosInstance.get(HOME_OFFICE_DAYS, {
                    params: {
                        user_id: currentUser.id,
                        from_date: firstDayOfWeek, // Already in YYYY-MM-DD format
                    }
                });
                setHomeOfficeStatus(response.data.map((item : any) => item.date));
            } catch (error) {
                console.error('Error fetching home office status:', error);
            }
        };

        if (!isNaN(selectedWeek) && !isNaN(selectedYear) && selectedUser) {
            fetchWeeklyLogs();
            fetchWeeklyHoliday();
            fetchHomeOfficeDays();
            fetchHomeOfficeStatus();
        }
        // Remove adding/editing functionality for other users
        if (currentUser.id !== selectedUser) {
            setHideEditDeleteFunctionality(true);
        } else {
            setHideEditDeleteFunctionality(false);
        }
    }, [selectedUser, firstDayOfWeek]);

    const handleCloseModal = () => {
        setEditTaskDetails(null);
        setShowInputForm(false);
    };

    return (
        <>
            <Grid container spacing={2} style={{ display: "flex" }}>
                <Grid item xs={12} md={8}>
                    <FirstGrid className="welcome_banner">
                        <div>
                            <Title>Hello {currentUser.name}</Title>
                            <Subtitle>Welcome to your dashboard</Subtitle>
                        </div>
                        <Box
                            sx={{
                                fontWeight: "bold",
                                color: "#3B3B3B",
                            }}
                        >
                            {newCurrentDate}
                        </Box>
                    </FirstGrid>
                </Grid>
                <Grid item xs={12} md={4}>
                    <SecondGrid
                        sx={{
                            backgroundColor: `${
                                calculateHoursPerDay(
                                    currentWeekLogs,
                                    selectedWeek,
                                    selectedYear,
                                    nationalHolidays,
                                    weeklyHolidays,
                                ).color
                            }`,
                        }}
                    >
                        <Box 
                            sx={{
                                mr: 2,
                                borderRadius: "100%",
                                padding: 1,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: `${
                                    calculateHoursPerDay(
                                        currentWeekLogs,
                                        selectedWeek,
                                        selectedYear,
                                        nationalHolidays,
                                        weeklyHolidays,
                                    ).circleColor
                                }`,
                            }}
                        >
                            <ThumbUpIcon
                                sx={{
                                    borderRadius: "100%",
                                    color: `${
                                        calculateHoursPerDay(
                                            currentWeekLogs,
                                            selectedWeek,
                                            selectedYear,
                                            nationalHolidays,
                                            weeklyHolidays,
                                        ).textColor
                                    }`,
                                }}
                            />
                        </Box>

                        <Box
                            sx={{
                                fontWeight: "bold",
                                color: `${
                                    calculateHoursPerDay(
                                        currentWeekLogs,
                                        selectedWeek,
                                        selectedYear,
                                        nationalHolidays,
                                        weeklyHolidays,
                                    ).textColor
                                }`,
                            }}
                        >
                            {
                                calculateHoursPerDay(
                                    currentWeekLogs,
                                    selectedWeek,
                                    selectedYear,
                                    nationalHolidays,
                                    weeklyHolidays,
                                ).message
                            }
                        </Box>
                    </SecondGrid>
                </Grid>
                <Grid item xs={12} md={8}>
                    <FormControl
                        style={{ marginBottom: "12px", marginLeft: "8px" }}
                    >
                        <InputLabel id="user-select-label">
                            Select User
                        </InputLabel>
                        <Select
                            labelId="user-select-label"
                            label="Select User"
                            id="user-select"
                            value={users.length > 0 ? selectedUser : ""}
                            onChange={async (e) => {
                                if(e.target.value) {
                                    setSelectedUser(+e.target.value);
                                    const responseUserID = await axiosInstance.get(
                                        SELECTED_USER_ID_URL(+e.target.value)
                                    );

                                    setCurrentSelectedUser(
                                        responseUserID.data.data
                                    );
                                }
                            }}
                            style={{ minWidth: "200px" }}
                        >
                            {users.map((user) => (
                                <MenuItem key={user.id} value={user.id}>
                                    {user.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography
                        variant="body1"
                        fontWeight="bold"
                        mb="4px"
                        color="#3B3B3B"
                    ></Typography>
                </Grid>
                <Grid item xs={12} md={8}>
                    <Box>
                        <>
                            <List>
                                {daysOfWeek.map((day, i) => (
                                    <ListItem
                                        key={i}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <DailyTasks
                                            toggleHomeOffice={toggleHomeOffice}
                                            isHomeOfficeDay={isHomeOfficeDay}
                                            firstDayOfWeek={firstDayOfWeek}
                                            weekdayName={day.weekdayName}
                                            weekDayDate={day.weekDayDate}
                                            currentWeekLogs={currentWeekLogs}
                                            selectedItemIndices={
                                                selectedItemIndices
                                            }
                                            i={i}
                                            showInputForm={showInputForm}
                                            setShowInputForm={setShowInputForm}
                                            setOpenedDateTrackerForm={
                                                setOpenedDateTrackerForm
                                            }
                                            setCurrentWeekLogs={
                                                setCurrentWeekLogs
                                            }
                                            selectedYear={selectedYear}
                                            selectedWeek={selectedWeek}
                                            setEditTaskDetails={
                                                setEditTaskDetails
                                            }
                                            hideEditDeleteFunctionality={
                                                hideEditDeleteFunctionality
                                            }
                                        />
                                        <IconButton
                                            sx={{
                                                width: "36px",
                                                height: "36px",
                                            }}
                                            onClick={() =>
                                                toggleSelectedItem(i)
                                            }
                                        >
                                            {selectedItemIndices.includes(i) ? (
                                                <KeyboardArrowUpIcon />
                                            ) : (
                                                <KeyboardArrowDownIcon />
                                            )}
                                        </IconButton>
                                    </ListItem>
                                ))}
                            </List>
                        </>
                        <Typography
                                className={`weekend-log ${showWeekendLog ? 'open' : 'closed'}`}
                                onClick={()=>{setShowWeekendLog(!showWeekendLog)}}
                                variant="body1"
                                fontWeight="bold"
                                mb="4px"
                                color="#3B3B3B"
                                marginTop="2rem"
                            >
                                Weekend <ExpandMoreIcon/>
                            </Typography>

                        {showWeekendLog ? (
                        <>
                        <List>
                                {weekend.map((day, i) => (
                                    <ListItem
                                        key={i+5}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <DailyTasks
                                            toggleHomeOffice={toggleHomeOffice}
                                            isHomeOfficeDay={isHomeOfficeDay}
                                            firstDayOfWeek={firstDayOfWeek}
                                            weekdayName={day.weekdayName}
                                            weekDayDate={day.weekDayDate}
                                            currentWeekLogs={currentWeekLogs}
                                            selectedItemIndices={selectedItemIndices}
                                            i={i+5}
                                            showInputForm={showInputForm}
                                            setShowInputForm={setShowInputForm}
                                            setOpenedDateTrackerForm={setOpenedDateTrackerForm}
                                            setCurrentWeekLogs={setCurrentWeekLogs}
                                            selectedYear={selectedYear}
                                            selectedWeek={selectedWeek}
                                            setEditTaskDetails={setEditTaskDetails}
                                            hideEditDeleteFunctionality={hideEditDeleteFunctionality}
                                        />
                                        <IconButton
                                            sx={{
                                                width: "36px",
                                                height: "36px",
                                            }}
                                            onClick={() =>
                                                toggleSelectedItem(i+5)
                                            }
                                        >
                                            {selectedItemIndices.includes(i+5) ? (
                                                <KeyboardArrowUpIcon />
                                            ) : (
                                                <KeyboardArrowDownIcon />
                                            )}
                                        </IconButton>
                                    </ListItem>
                                ))}
                            </List>
                        </>
                        ) : "" }
                    </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Grid item xs={12} md={12} mt="12px">
                        <Box>
                            <Typography
                                variant="body1"
                                fontWeight="bold"
                                mb="4px"
                                color="#3B3B3B"
                            >
                                TRACKING
                            </Typography>
                            <Grid container spacing={2} alignItems="center">
                                {daysOfWeek.map((day, i) => (
                                    <Grid item key={i}>
                                        <VerticalProgressBar
                                            nationalHolidays={nationalHolidays}
                                            isWeekend={false}
                                            weekdayName={day?.weekdayName}
                                            weekDayDate={day?.weekDayDate}
                                            currentWeekLogs={currentWeekLogs}
                                            holidays={weeklyHolidays}
                                        />
                                    </Grid>
                                ))}

                                {weekend.map((day, i) => (
                                    <Grid item key={i+5}>
                                        <VerticalProgressBar
                                            nationalHolidays={nationalHolidays}
                                            isWeekend={true}
                                            weekdayName={day?.weekdayName}
                                            weekDayDate={day?.weekDayDate}
                                            currentWeekLogs={currentWeekLogs}
                                            holidays={weeklyHolidays}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={12} mt="12px">
                        <Typography
                            variant="body1"
                            fontWeight="bold"
                            textTransform="uppercase"
                            mb="4px"
                            color="#3B3B3B"
                        >
                            Clients
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "8px",
                                marginBottom: "8px",
                            }}
                            >
                            <ul className="clients_list">
                                {currentSelectedUser.clients && currentSelectedUser.clients.length > 0 ? (
                                    currentSelectedUser.clients.map((client) => (
                                    <li key={client.id}>
                                        <span>{client.name}</span>
                                        <span>{(client?.pivot?.hours != null) ? `${client.pivot.hours}h` : ''}</span>
                                    </li>
                                ))
                            ) : (
                                <li>No clients assigned.</li>
                            )}                       
                            </ul>
                        </Box>
                        <Typography
                            variant="body1"
                            fontWeight="bold"
                            textTransform="uppercase"
                            mb="4px"
                            color="#3B3B3B"
                        >
                            Monthly Summary
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "8px",
                                marginBottom: "8px",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    bgcolor: "#feedc2",
                                    borderRadius: "100%",
                                    width: 40,
                                    height: 40,
                                }}
                            >
                                <BeachAccessIcon
                                    style={{
                                        color: "#f7c232",
                                    }}
                                />
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: "12px",
                                    marginRight: "10px",
                                }}
                            >
                                <span
                                    style={{
                                        marginRight: "8px",
                                        fontSize: "24px",
                                        fontWeight: "bold",
                                        color: "#3B3B3B",
                                    }}
                                >
                                    {getHolidaysInCurrentMonth(
                                        allListOfHolidays
                                    )}
                                </span>
                                <span
                                    style={{
                                        color: "#3B3B3B",
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <small
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "12px",
                                        }}
                                    >
                                        Holidays
                                    </small>
                                    <small
                                        style={{
                                            marginTop: "-4px",
                                            fontSize: "10px",
                                            color: "gray",
                                        }}
                                    >
                                        for the current month
                                    </small>
                                </span>
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    bgcolor: "#91c993",
                                    borderRadius: "100%",
                                    width: 40,
                                    height: 40,
                                }}
                            >
                                <HomeWorkIcon
                                    style={{
                                        color: "#509452",
                                    }}
                                />
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: "12px",
                                }}
                            >
                                <span
                                    style={{
                                        marginRight: "8px",
                                        fontSize: "24px",
                                        fontWeight: "bold",
                                        color: "#3B3B3B",
                                    }}
                                >
                                    {homeOfficeDaysCount}
                                </span>
                                <span
                                    style={{
                                        color: "#3B3B3B",
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <small
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: "12px",
                                        }}
                                    >
                                        Home Office Days
                                    </small>
                                    <small
                                        style={{
                                            marginTop: "-4px",
                                            fontSize: "10px",
                                            color: "gray",
                                        }}
                                    >
                                        for the current month
                                    </small>
                                </span>
                            </Box>
                        </Box>

                        <Box
                            sx={{
                                marginTop: "24px",
                            }}
                        >
                            <Typography
                                variant="body1"
                                fontWeight="bold"
                                color="#3B3B3B"
                                textTransform="uppercase"
                            >
                                Holidays summary
                            </Typography>

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "flex-end",
                                    marginTop: "8px",
                                }}
                            >
                                <p
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: "24px",
                                        color: "green",
                                    }}
                                >
                                    {currentSelectedUser.available_days_left_all}
                                </p>
                                <small
                                    style={{
                                        marginLeft: "8px",
                                        marginBottom: "4px",
                                        fontWeight: "bold",
                                        color: "gray",
                                    }}
                                >
                                    days available
                                </small>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "12px",
                            }}
                        >
                             <>
                                <CircularIndicator
                                    color="#338ccd"
                                    holidaysUsed={
                                        currentSelectedUser?.available_days_left_prev
                                    }
                                    holidaysLeft={
                                        currentSelectedUser?.available_days_prev
                                    }
                                    year={new Date().getFullYear() - 1}
                                />
                            </>
                            <>
                                <CircularIndicator
                                    color="#338ccd"
                                    holidaysUsed={
                                        currentSelectedUser?.available_days_left_current
                                    }
                                    holidaysLeft={
                                        currentSelectedUser?.available_days_current
                                    }
                                    year={new Date().getFullYear()}
                                />
                            </>
                            <>
                                <CircularIndicator
                                    color="#338ccd"
                                    holidaysUsed={
                                        currentSelectedUser?.available_days_left_next
                                    }
                                    holidaysLeft={
                                        currentSelectedUser?.available_days_next
                                    }
                                    year={new Date().getFullYear() + 1}
                                />
                            </>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            {showInputForm && (
                <TrackerForm
                    openedDateTrackerForm={openedDateTrackerForm}
                    onClose={handleCloseModal}
                    setCurrentWeekLogs={setCurrentWeekLogs}
                    selectedWeek={selectedWeek}
                    selectedYear={selectedYear}
                    firstDayOfWeek={firstDayOfWeek}
                    editTaskDetails={editTaskDetails}
                />
            )}
        </>
    );
};

export default AdminDashboard;
